import types from './types'

export const fixedFooter = () => ({type: types.FIXED_FOOTER})
export const fixedFooterClear = () => ({type: types.FIXED_FOOTER_CLEAR})

export const homePageMsg = (payload) => ({type: types.HOME_MSG, payload})
export const homePageMsgClear = () => ({type: types.HOME_MSG_CLEAR})

export const homePageShowMsg = (payload) => ({type: types.SHOW_HOME_MSG, payload})

export const checkContentAccess = (payload) => ({type: types.CONTENT_ACCESS, payload})
export const checkContentAccessResponse = (payload) => ({type: types.CONTENT_ACCESS_RESPONSE, payload})
export const checkContentAccessClear = () => ({type: types.CONTENT_ACCESS_CLEAR})

export const setBreadcrumbStack = (payload) => ({type: types.BREADCRUMB_STACK, payload})
export const clearBreadcrumbStack = () => ({type: types.CLEAR_BREADCRUMB_STACK})

export const setSectionLazyLoad = (payload) => ({type: types.SECTION_LAZY_LOAD, payload})
export const clearSectionLazyLoad = () => ({type: types.CLEAR_SECTION_LAZY_LOAD})

// Smart Bar Section
export const getSmartBar = (payload) => ({type: types.SMART_BAR, payload})
export const getSmartBarResponse = (payload) => ({type: types.SMART_BAR_RESPONSE, payload})
export const getSmartBarClear = () => ({type: types.SMART_BAR_CLEAR})

// LOGIN LOGO
export const getLoginLogo = (payload) => ({type: types.LOGIN_LOGO, payload})
export const getLoginLogoResponse = (payload) => ({type: types.LOGIN_LOGO_RESPONSE, payload})
export const getLoginLogoClear = () => ({type: types.LOGIN_LOGO_CLEAR})

// LOGIN LOGO
export const setGoogleClientId = (payload) => ({type: types.GOOGLE_CLIENT_ID, payload})
export const setGoogleClientIdClear = () => ({type: types.GOOGLE_CLIENT_ID_CLEAR})


// BLINK LIVE
export const setLiveBlink = (payload) => ({type: types.BLINK_LIVE, payload})
export const setNotificationBlink = (payload) => ({type: types.BLINK_NOTIFICATION, payload})
// Active header

export const getActiveHeader = (payload) => ({type: types.ACTIVE_HEADER, payload})
export const getActiveHeaderClear = (payload) => ({type: types.ACTIVE_HEADER_CLEAR, payload})

export const getShowLoader = (payload) => ({type: types.SHOW_LOADER, payload})
export const getShowLoaderClear = (payload) => ({type: types.SHOW_LOADER_CLEAR, payload})

//New Content Count
export const getNewContentCount = (payload) => ({type: types.NEW_CONTENT_COUNT, payload})
export const getNewContentCountResponse = (payload) => ({type: types.NEW_CONTENT_COUNT_RESPONSE, payload})
export const getNewContentCountClear = () => ({type: types.NEW_CONTENT_COUNT_RESPONSE_CLEAR})


